import { Routes, Route } from "react-router-dom";
import Index from "./pages/home";
import style from "./assets/css/style.css";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
    </Routes>
  );
}